import {
  FileUploaderArchiveExtension,
  FileUploaderAudioExtention,
  FileUploaderDocumentExtension,
  FileUploaderExelExtension,
  FileUploaderExtension,
  FileUploaderImageExtension,
  FileUploaderPresentationExtention,
  FileUploaderVideoExtension,
} from "../types";

const imageExtensions: FileUploaderImageExtension[] = [
  "gif",
  "jpg",
  "jpeg",
  "png",
  "svg",
  "webp",
];

const archiveExtensions: FileUploaderArchiveExtension[] = ["zip", "rar", "tgz"];

export const videoExtensions: FileUploaderVideoExtension[] = [
  "mp4",
  "avi",
  "mkv",
  "flv",
  "mov",
  "webm"
];

const documentExtensions: FileUploaderDocumentExtension[] = [
  "doc",
  "docm",
  "docx",
  "html",
  "txt",
  "xml",
  "json",
  "pdf",
];

const excelExtensions: FileUploaderExelExtension[] = [
  "xlsx",
  "xlsm",
  "xlsb",
  "xltx",
  "xltm",
  "csv",
];

const presentationExtensions: FileUploaderPresentationExtention[] = [
  "pptx",
  "pptm",
  "ppsm",
  "ppsx",
];

const audioExtensions: FileUploaderAudioExtention[] = ["mp3", "ogg"];

/** Объединенный массив всех расширений */
export const allExtensions: FileUploaderExtension[] = [
  ...imageExtensions,
  ...archiveExtensions,
  ...videoExtensions,
  ...documentExtensions,
  ...excelExtensions,
  ...presentationExtensions,
  ...audioExtensions,
];
